// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1CAl6","requiredAsterisk":"Info_requiredAsterisk__44_bo"};